<template>
    <div
        :style="`width: ${width}%;height: ${height}%;overflow: hidden;z-index: 0;position: relative;`"
    />
</template>

<script>
import vtkRemoteView from "vtk.js/Sources/Rendering/Misc/RemoteView";

export default {
    name: "VtkView",
    props: {
        viewId: {
            type: String,
            default: "-1"
        },
        width: {
            type: Number,
            default: 100
        },
        height: {
            type: Number,
            default: 100
        }
    },
    data() {
        return {
            connected: false
        };
    },
    watch: {
        viewId(viewId) {
            if (this.connected) {
                this.view.setViewId(viewId);
                this.view.render();
            }
        },
        width() {
            this.view.resize();
        },
        height() {
            this.view.resize();
        }
    },
    created() {
        this.view = vtkRemoteView.newInstance({
            rpcWheelEvent: "viewport.mouse.zoom.wheel"
        });
        if (location.hostname.split(".")[0] === "localhost") {
            this.view.setInteractiveRatio(1);
        }
    },
    mounted() {
        this.view.setContainer(this.$el);
        window.addEventListener("resize", this.view.resize);
    },
    beforeDestroy() {
        this.view.delete();
        window.removeEventListener("resize", this.view.resize);
    },
    methods: {
        connect(session) {
            this.view.setSession(session);
            this.view.setViewId(this.viewId);
            this.connected = true;
            this.view.resize();
            this.view.render();
        }
    }
};
</script>
